import { Component } from '@angular/core';

@Component({
  selector: 'app-social-icons',
  templateUrl: './social-icons.component.html',
  styleUrls: ['./social-icons.component.css']
})
export class SocialIconsComponent {

}



// WEBPACK FOOTER //
// ./src/app/structural_components/footer/social-icons/social-icons.component.ts